/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var rootScopeService = require('../root-scope.service');
var handleServiceError = require('../handle-error.service');

/**
 * Appends necessary parameters as query params to the redirect url
 * @param {String} url - Redirect URL
 * @param {Array} params - Parameters required to be appended to
 * the redirect URL
 * @returns {String} url - Redirect URL with all query params appended
 */
function constructQueryParams(url, params) {
    if (params) {
        url += url.indexOf('?') === -1 ? '?' : '&';
        url += 'listUrl=' + encodeURIComponent(rootScopeService.getOriginalListUrl());

        if (params.length > 0) {
            url += '&';
        }

        for (var i = 0; i < params.length; i++) {
            url += params[i].name + '=' + encodeURIComponent(params[i].value);

            if (i != params.length - 1) {
                url += '&';
            }
        }
    }
    return url;
}

/**
 * Builds a query string to finalize the payment. and redirect to it
 *
 * @param redirectData The data containing the url and parameters
 */
function redirect(redirectData) {
    /**
     * URL must be present in `redirectData` object.
     */
    if (!redirectData || !redirectData.url) {
        return handleServiceError(redirectData);
    }

    var url = redirectData.url;
    var params = redirectData.parameters;
    var suppress = redirectData.suppressIFrame !== undefined ? redirectData.suppressIFrame : rootScopeService.getSuppressIFrameDefault();
    url = constructQueryParams(url, params);

    if (suppress) {
        window.top.location.replace(url);
    } else {
        window.location.replace(url);
    }
}

module.exports = { constructQueryParams, redirect };
